/* LINIAN theme scripts */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = window.LINIAN || { routes: { root: '/' }, cartType: 'drawer' };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header height, sticky shadow ---------- */
  const header = $('[data-header]');
  const setHeaderH = () => {
    if (!header) return;
    const sticky = header.classList.contains('header--sticky');
    document.documentElement.style.setProperty('--header-h', sticky ? header.offsetHeight + 'px' : '0px');
  };
  setHeaderH();
  window.addEventListener('resize', setHeaderH);
  window.addEventListener('scroll', () => header && header.classList.toggle('is-scrolled', window.scrollY > 8), { passive: true });

  /* ---------- Announcement rotator ---------- */
  $$('[data-announce]').forEach(bar => {
    const msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
    let t = setInterval(next, speed);
    function next() { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }
    bar.addEventListener('mouseenter', () => clearInterval(t));
    bar.addEventListener('mouseleave', () => { t = setInterval(next, speed); });
  });

  /* ---------- Drawers & overlays ---------- */
  const scrim = $('[data-scrim]');
  let openEl = null, lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    if (openEl && openEl !== el) closePanel(true);
    lastFocus = document.activeElement;
    el.hidden = false;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('is-visible')); }
    requestAnimationFrame(() => el.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    openEl = el;
    const f = el.querySelector('input[type="search"], button, a[href], input');
    if (f) setTimeout(() => f.focus(), 60);
    $$(`[aria-controls="${el.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
  }
  function closePanel(instant) {
    if (!openEl) return;
    const el = openEl;
    el.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-visible');
    const done = () => { if (!el.classList.contains('is-open')) el.hidden = true; if (scrim && !openEl) scrim.hidden = true; };
    instant || reduceMotion ? done() : setTimeout(done, 300);
    document.body.style.overflow = '';
    $$(`[aria-controls="${el.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    openEl = null;
    if (lastFocus && !instant) lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openPanel(document.getElementById(opener.dataset.drawerOpen)); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-search-close]') || e.target.matches('[data-scrim]')) { closePanel(); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openPanel($('#SearchOverlay')); return; }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && R.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openPanel($('#CartDrawer')); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePanel(); });
  const mq = window.matchMedia('(min-width: 990px)');
  mq.addEventListener('change', () => { if (openEl && openEl.id === 'FilterDrawer') closePanel(true); });

  /* ---------- Hero slideshow ---------- */
  $$('[data-slideshow]').forEach(show => {
    const slides = $$('.slide', show), dots = $$('.hero__dot', show), pauseBtn = $('[data-pause]', show);
    if (slides.length < 2) return;
    const secs = parseInt(show.dataset.speed, 10) || 6;
    show.style.setProperty('--dot-time', secs + 's');
    let i = 0, timer = null, paused = show.dataset.autoplay !== 'true' || reduceMotion;
    const go = n => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) { dots[i].classList.remove('is-active'); void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
      restart();
    };
    const restart = () => { clearTimeout(timer); if (!paused) timer = setTimeout(() => go(i + 1), secs * 1000); };
    const setPaused = p => { paused = p; show.classList.toggle('is-paused', p); if (pauseBtn) { pauseBtn.firstElementChild.textContent = p ? 'Play' : 'Pause'; pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow'); } restart(); };
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    pauseBtn && pauseBtn.addEventListener('click', () => setPaused(!paused));
    let x0 = null;
    show.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    setPaused(paused);
  });

  /* ---------- Rails ---------- */
  function bindRails(root = document) {
    $$('[data-rail]', root).forEach(rail => {
      const track = $('[data-rail-track]', rail), prev = $('[data-rail-prev]', rail), next = $('[data-rail-next]', rail);
      if (!track || !prev || rail.dataset.bound) return;
      rail.dataset.bound = '1';
      const step = () => { const item = track.firstElementChild; return item ? (item.offsetWidth + 20) * 2 : 300; };
      const sync = () => { prev.disabled = track.scrollLeft < 8; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }
  bindRails();

  /* ---------- Cart ---------- */
  const drawerId = 'cart-drawer';
  async function renderCart(open) {
    const res = await fetch(`${R.routes.root}?sections=${drawerId}`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data[drawerId], 'text/html');
    const fresh = html.querySelector('#CartDrawer');
    const current = $('#CartDrawer');
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (open && !wasOpen) openPanel(current);
    }
    const cart = await (await fetch(`${R.routes.cart}.js`)).json();
    $$('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.classList.toggle('is-empty', cart.item_count === 0); });
    return cart;
  }
  async function addToCart(items) {
    const res = await fetch(`${R.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Could not add to bag');
    if (R.cartType === 'page') { window.location.href = R.routes.cart; return; }
    await renderCart(true);
  }
  async function changeLine(line, quantity) {
    const d = $('#CartDrawer'); d && d.classList.add('is-busy');
    try {
      await fetch(`${R.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      await renderCart(false);
    } finally { const d2 = $('#CartDrawer'); d2 && d2.classList.remove('is-busy'); }
  }

  // Product forms
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-button]');
    const err = form.querySelector('[data-form-error]');
    const id = form.querySelector('[name="id"]').value;
    const qtyInput = form.querySelector('[name="quantity"]');
    btn && btn.classList.add('is-loading');
    if (err) err.hidden = true;
    try { await addToCart([{ id: Number(id), quantity: qtyInput ? Number(qtyInput.value) || 1 : 1 }]); }
    catch (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } }
    finally { btn && btn.classList.remove('is-loading'); }
  });

  // Quick add sizes & cart drawer controls
  document.addEventListener('click', async e => {
    const size = e.target.closest('.card__size');
    if (size) {
      size.classList.add('is-loading');
      try { await addToCart([{ id: Number(size.dataset.variantId), quantity: 1 }]); size.classList.add('is-added'); setTimeout(() => size.classList.remove('is-added'), 1600); }
      catch (ex) { alert(ex.message); }
      finally { size.classList.remove('is-loading'); }
      return;
    }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const wrap = q.closest('[data-qty]'); const input = wrap.querySelector('input');
      const min = input.min !== '' ? Number(input.min) : 0;
      input.value = Math.max(min, (Number(input.value) || 0) + Number(q.dataset.qtyChange));
      if (input.dataset.lineQty) changeLine(Number(input.dataset.lineQty), Number(input.value));
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) changeLine(Number(rm.dataset.lineRemove), 0);
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(Number(input.dataset.lineQty), Math.max(0, Number(input.value) || 0));
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(root => {
    const variantsEl = $('[data-variants]', root);
    const form = $('form[data-ajax-cart]', root);
    const idInput = form && $('[data-variant-input]', form);
    const addBtn = form && $('[data-add-button]', form);
    const addLabel = form && $('[data-add-label]', form);
    const barBtn = $('[data-bar-add]', root);
    const list = $('[data-media-list]', root);
    const dots = $$('.pdp__dot', root);

    // gallery dots (mobile)
    if (list && dots.length) {
      list.addEventListener('scroll', () => {
        const w = list.firstElementChild.offsetWidth + 6;
        const n = Math.round(list.scrollLeft / w);
        dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
      }, { passive: true });
    }

    // sticky bar (mobile)
    const bar = $('[data-sticky-bar]', root);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      bar.hidden = false;
      new IntersectionObserver(([en]) => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
    }

    if (!variantsEl || !idInput) return;
    const variants = JSON.parse(variantsEl.textContent);
    const fieldsets = $$('.opt', root);
    const money = cents => {
      const fmt = R.moneyFormat || '₹{{amount}}';
      const v = (cents / 100);
      const withCommas = n => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
        if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-IN');
        if (k === 'amount_with_comma_separator') return withCommas(v).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
        if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('de-DE');
        return withCommas(v);
      });
    };
    const priceHTML = v => {
      let h = `<div class="price${v.compare_at_price > v.price ? ' price--sale' : ''}" data-price><span class="price__now">${money(v.price)}</span>`;
      if (v.compare_at_price > v.price) h += `<s class="price__was"><span class="visually-hidden">Regular price</span>${money(v.compare_at_price)}</s><span class="price__off">${Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)}% off</span>`;
      return h + '</div>';
    };
    const selected = () => fieldsets.map(fs => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const markAvailability = sel => {
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const ok = variants.some(v => v.available && v.options.every((o, k) => o === test[k]));
          const lab = inp.nextElementSibling; lab && lab.classList.toggle('is-unavailable', !ok);
        });
      });
    };
    const update = () => {
      const sel = selected();
      fieldsets.forEach((fs, k) => { const out = $('[data-option-value]', fs); if (out) out.textContent = sel[k] || ''; });
      markAvailability(sel);
      const v = variants.find(x => x.options.every((o, k) => o === sel[k]));
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; if (barBtn) barBtn.disabled = true; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (barBtn) barBtn.disabled = !v.available;
      $$('[data-price-wrap] [data-price], [data-bar-price] [data-price]', root).forEach(p => { p.outerHTML = priceHTML(v); });
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_media && list) {
        const item = list.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        if (item) {
          if (mq.matches) { list.prepend(item); }
          else list.scrollTo({ left: item.offsetLeft - 20, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    };
    fieldsets.forEach(fs => fs.addEventListener('change', update));
    markAvailability(selected());
  });

  /* ---------- Dialogs ---------- */
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-dialog-open]');
    if (o) { const d = document.getElementById(o.dataset.dialogOpen); d && d.showModal && d.showModal(); return; }
    const c = e.target.closest('[data-dialog-close]');
    if (c) { const d = c.closest('dialog'); d && d.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Collection filters & sort ---------- */
  document.addEventListener('change', e => {
    const el = e.target.closest('[data-autosubmit]');
    if (!el) return;
    const sortForm = el.closest('[data-sort-form]');
    if (sortForm) { sortForm.submit(); return; }
    const filterForm = el.closest('[data-filter-form]');
    if (filterForm && mq.matches) filterForm.submit();
  });
  $$('[data-filter-form]').forEach(f => f.addEventListener('submit', () => {
    $$('input[type="number"]', f).forEach(i => { if (i.value === '') i.disabled = true; });
  }));

  /* ---------- Recommendations ---------- */
  $$('[data-recs]').forEach(async sec => {
    if (sec.querySelector('.grid')) return;
    try {
      const res = await fetch(sec.dataset.url);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = html.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; bindRails(sec); }
    } catch (_) {}
  });

  /* ---------- Login: recover toggle ---------- */
  const rec = $('[data-toggle-recover]');
  if (rec) rec.addEventListener('click', e => { e.preventDefault(); $('#RecoverPanel').classList.toggle('is-open'); });
})();
